import proposalSettingsSchema from '../proposalSettings/proposalSettingsSchema';
// Version 1 is the shared dbVersion. Version 2 stores signedPdfUrl (LAE-749);
// see proposalMigrationStrategies.
export const PROPOSAL_SCHEMA_VERSION = 2;

export default {
  title: 'proposal schema',
  version: PROPOSAL_SCHEMA_VERSION,
  keyCompression: true,
  primaryKey: 'uuid',
  type: 'object',
  required: [
    'uuid',
    'number',
    'title',
    'client',
    'subtotal_price',
    'price_with_discount',
    'tax_value',
    'price_with_tax',
    'status',
    'description',
    'contactId',
    'items',
    'isDraft',
    'visible',
    'sentAt',
    'createdAt',
    'updatedAt',
    'createdBy',
    'updatedBy',
    'settings',
    'workspaceId',
  ],
  properties: {
    uuid: {
      type: 'string',
      maxLength: 100,
    },
    number: {
      type: ['number', 'null'],
    },
    title: {
      type: ['string', 'null'],
    },
    client: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    subtotal_price: {
      type: 'number',
    },
    price_with_discount: {
      type: 'number',
    },
    tax_value: {
      type: 'number',
    },
    price_with_tax: {
      type: 'number',
    },
    description: {
      type: ['string', 'null'],
    },
    discountType: {
      type: 'string',
    },
    discountAmount: {
      type: 'string',
    },
    contactId: {
      type: 'string',
    },
    items: {
      type: 'array',
      items: {
        type: 'object',
        required: ['description', 'qty', 'unitPrice'],
        properties: {
          description: {
            type: 'string',
          },
          qty: {
            type: 'number',
          },
          unitPrice: {
            type: 'number',
          },
        },
      },
    },
    isDraft: {
      type: 'boolean',
    },
    visible: {
      type: 'boolean',
    },
    sentAt: {
      type: ['number', 'null'],
    },
    createdAt: {
      type: ['number', 'null'],
    },
    updatedAt: {
      type: ['number', 'null'],
    },
    createdBy: {
      type: ['string', 'null'],
    },
    updatedBy: {
      type: ['string', 'null'],
    },
    settings: proposalSettingsSchema,
    workspaceId: {
      type: 'string',
      maxLength: 36,
    },
    signedPdfUrl: {
      type: ['string', 'null'],
    },
  },
  indexes: ['workspaceId'],
};
